/* Loupe – small vanilla web components. No framework, no dependencies. */
(() => {
  const sbw = () => document.documentElement.style.setProperty('--sbw', (innerWidth - document.documentElement.clientWidth) + 'px');
  sbw(); addEventListener('resize', sbw, { passive: true }); addEventListener('load', sbw);
  if ('ResizeObserver' in window) new ResizeObserver(sbw).observe(document.documentElement);   // scrollbar appears/disappears as content grows
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const L = window.Loupe || {};

  const toast = (msg) => {
    const t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false; clearTimeout(t._t);
    t._t = setTimeout(() => (t.hidden = true), 2600);
  };
  const lock = (on) => document.body.classList.toggle('is-locked', on);

  /* ---------- drawers: menu, cart, filters ---------- */
  class LoupeDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => { if (e.target.closest('[data-drawer-close]')) this.close(); });
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); if (e.key === 'Tab') this.trap(e); });
    }
    open(opener) {
      this.opener = opener || document.activeElement;
      this.classList.add('is-open'); this.dataset.opened = ''; this.setAttribute('aria-hidden', 'false'); lock(true);
      requestAnimationFrame(() => { const f = this.querySelector('[data-autofocus]') || this.querySelector('button, a, input'); f && f.focus(); });
    }
    close() {
      this.classList.remove('is-open'); this.setAttribute('aria-hidden', 'true'); lock(false);
      this.dispatchEvent(new CustomEvent('loupe:drawer-close', { bubbles: true }));
      this.opener && this.opener.focus && this.opener.focus();
    }
    trap(e) {
      const f = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', this).filter((x) => x.offsetParent && !x.closest('[inert], [hidden]'));
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  customElements.define('loupe-drawer', LoupeDrawer);
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-drawer-open]'); if (!b) return;
    const d = document.getElementById(b.dataset.drawerOpen); if (!d) return;
    e.preventDefault(); d.open(b);
  });

  /* ---------- header: sticky hide on scroll, mega menus ---------- */
  class LoupeHeader extends HTMLElement {
    connectedCallback() {
      const wrap = this.closest('.header-wrapper') || this;
      const setH = () => document.documentElement.style.setProperty('--header-h', wrap.offsetHeight + 'px');
      setH(); addEventListener('resize', setH, { passive: true });
      this.fitNav(); document.fonts && document.fonts.ready.then(() => { this.lastW = 0; this.fitNav(); });
      new ResizeObserver(() => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => { this.fitNav(); setH(); }); }).observe(this);
      let last = 0;
      const sticky = this.dataset.sticky;
      addEventListener('scroll', () => {
        const y = scrollY;
        wrap.classList.toggle('is-scrolled', y > 10);
        if (sticky === 'scroll-up') wrap.classList.toggle('is-hidden', y > last && y > 200 && !this.querySelector('.is-open'));
        last = y;
      }, { passive: true });
      $$('[data-menu-toggle]', this).forEach((btn) => {
        const panel = document.getElementById(btn.getAttribute('aria-controls'));
        const fill = () => { const tpl = panel && panel.querySelector(':scope > template[data-mega-tpl]'); if (tpl) tpl.replaceWith(tpl.content); };
        const set = (on) => { if (on) fill(); btn.setAttribute('aria-expanded', on); panel && panel.classList.toggle('is-open', on); };
        let t;
        btn.addEventListener('click', () => set(btn.getAttribute('aria-expanded') !== 'true'));
        btn.addEventListener('pointerenter', fill, { once: true }); btn.addEventListener('focus', fill, { once: true });
        const li = btn.closest('li');
        if (matchMedia('(hover:hover)').matches) {
          li.addEventListener('mouseenter', () => { clearTimeout(t); $$('[data-menu-toggle][aria-expanded=true]', this).forEach((o) => o !== btn && o.click()); set(true); });
          li.addEventListener('mouseleave', () => { t = setTimeout(() => set(false), 120); });
        }
        li.addEventListener('keydown', (e) => { if (e.key === 'Escape') { set(false); btn.focus(); } });
        li.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) set(false); });
      });
    }
    // Collapse to the burger when the menu would wrap onto a second line.
    fitNav() {
      const nav = this.querySelector('.header__nav');
      if (!nav || !nav.children.length || innerWidth < 990) return this.classList.remove('is-collapsed');
      if (this.lastW === this.offsetWidth) return;
      this.lastW = this.offsetWidth;
      this.classList.remove('is-collapsed');
      const items = nav.children;
      this.classList.toggle('is-collapsed', items[items.length - 1].offsetTop > items[0].offsetTop + 4);
    }
  }
  customElements.define('loupe-header', LoupeHeader);

  /* mobile menu: drill-down panels */
  const mmShow = (mm, panel, opener) => {
    const root = mm.querySelector('[data-mm-panel=root]');
    panel.hidden = false; void panel.offsetWidth;   // let the slide-in transition run
    mm.classList.add('is-sub'); panel.classList.add('is-active'); root.inert = true;
    opener.setAttribute('aria-expanded', 'true'); mm.opener = opener; mm.current = panel;
    const back = panel.querySelector('[data-mm-back]'); back && back.focus({ preventScroll: true });
  };
  const mmBack = (mm, instant) => {
    const panel = mm.current; if (!panel) return;
    mm.classList.remove('is-sub'); panel.classList.remove('is-active'); mm.querySelector('[data-mm-panel=root]').inert = false;
    if (mm.opener) { mm.opener.setAttribute('aria-expanded', 'false'); if (!instant) mm.opener.focus({ preventScroll: true }); }
    mm.current = null; setTimeout(() => { if (!panel.classList.contains('is-active')) panel.hidden = true; }, instant ? 0 : 420);
  };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-mm-open]');
    if (o) { const mm = o.closest('[data-mm]'), p = mm && mm.querySelector(`[data-mm-panel="${o.dataset.mmOpen}"]`); if (p) mmShow(mm, p, o); return; }
    const b = e.target.closest('[data-mm-back]'); if (b) mmBack(b.closest('[data-mm]'));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { const mm = e.target.closest && e.target.closest('[data-mm]'); if (mm && mm.current) { e.stopPropagation(); mmBack(mm); } } }, true);
  document.addEventListener('loupe:drawer-close', (e) => { const mm = e.target.querySelector && e.target.querySelector('[data-mm]'); if (mm) setTimeout(() => mmBack(mm, true), 400); });

  /* mega menu tabs: hover/focus switches the panel */
  document.addEventListener('mouseover', megaTab); document.addEventListener('focusin', megaTab);
  function megaTab(e) {
    const t = e.target.closest && e.target.closest('[data-mega-tab]'); if (!t) return;
    const mega = t.closest('.mega');
    $$('[data-mega-tab]', mega).forEach((x) => x.classList.toggle('is-active', x === t));
    $$('[data-mega-panel]', mega).forEach((p) => (p.hidden = p.dataset.megaPanel !== t.dataset.megaTab));
  }


  /* ---------- cart (ajax): add, change, refresh sections ---------- */
  const Cart = {
    sections: () => $$('[data-cart-section]').map((el) => el.dataset.cartSection),
    async refresh(sections) {
      if (sections) return this.render(sections);
      const ids = this.sections(); if (!ids.length) return;
      const r = await fetch(`${location.pathname}?sections=${ids.join(',')}`);
      this.render(await r.json());
    },
    render(map) {
      Object.entries(map || {}).forEach(([id, html]) => {
        $$(`[data-cart-section="${id}"]`).forEach((el) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector(`[data-cart-section="${id}"]`);
          if (fresh) el.innerHTML = fresh.innerHTML;
        });
      });
      document.dispatchEvent(new CustomEvent('loupe:cart-updated'));
    },
    async add(form) {
      const fd = new FormData(form);
      fd.append('sections', this.sections().join(','));
      fd.append('sections_url', location.pathname);
      const r = await fetch(L.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || L.strings.error);
      this.render(j.sections);
      return j;
    },
    async change(line, quantity) {
      const r = await fetch(L.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: this.sections(), sections_url: location.pathname }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || L.strings.error);
      this.render(j.sections);
      return j;
    },
    open() { const d = $('#cart-drawer'); if (d && L.cartType === 'drawer') d.open(); else location.href = L.routes.cart; }
  };
  window.LoupeCart = Cart;
  /* IGIOO: the sticky bar's button opens the lens selector when the product has one */
  document.addEventListener('click', (e) => { const b = e.target.closest('loupe-sticky-atc button[type=submit], .sticky-atc button[type=submit]'); const ls = document.querySelector('[data-lens-open]');
    if (b && ls) { e.preventDefault(); e.stopImmediatePropagation(); ls.click(); } }, true);
  /* apps and custom code can refresh (and open) the cart drawer: 'loupe:cart-refresh' or the common 'cart:refresh' event, detail { open: true } */
  const onRefresh = async (e) => { if (e.loupeDone) return; e.loupeDone = true; await Cart.refresh(); const d = e.detail || {}; if (d.open || d.openMiniCart) Cart.open(); };
  ['loupe:cart-refresh', 'cart:refresh'].forEach((ev) => { document.addEventListener(ev, onRefresh); document.documentElement.addEventListener(ev, onRefresh); });

  class LoupeProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form'); if (!this.form) return;
      this.form.addEventListener('submit', async (e) => {
        if (L.cartType !== 'drawer' && !this.dataset.ajax) return;
        e.preventDefault();
        const btn = this.form.querySelector('[type=submit]'); btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true');
        const err = this.querySelector('[data-form-error]'); if (err) err.hidden = true;
        try { await Cart.add(this.form); Cart.open(); }
        catch (x) { if (err) { err.textContent = x.message; err.hidden = false; } else toast(x.message); }
        finally { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
      });
    }
  }
  customElements.define('loupe-product-form', LoupeProductForm);

  class LoupeCartItems extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const rm = e.target.closest('[data-remove]'); if (rm) { e.preventDefault(); this.update(rm.dataset.remove, 0); }
        const st = e.target.closest('[data-step]'); if (st) { const inp = st.parentElement.querySelector('input'); const v = Math.max(0, (+inp.value || 0) + +st.dataset.step); inp.value = v; this.update(inp.dataset.line, v); }
      });
      this.addEventListener('change', (e) => { const inp = e.target.closest('input[data-line]'); if (inp) this.update(inp.dataset.line, Math.max(0, +inp.value || 0)); });
    }
    async update(line, qty) {
      this.classList.add('is-busy');
      try { await Cart.change(+line, qty); } catch (x) { toast(x.message); Cart.refresh(); }
      finally { this.classList.remove('is-busy'); }
    }
  }
  customElements.define('loupe-cart-items', LoupeCartItems);

  /* ---------- quantity input on product page ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.qty [data-qty]'); if (!b) return;
    const inp = b.parentElement.querySelector('input'); inp.value = Math.max(+inp.min || 1, (+inp.value || 1) + +b.dataset.qty);
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- variant picker: swaps the section via the Section Rendering API ---------- */
  const VARIANT_CACHE = new Map(), PRELOADED = new Set();
  class LoupeVariantPicker extends HTMLElement {
    connectedCallback() {
      /* the URL that renders the section for a set of chosen option values; hovering/focusing an option warms it */
      const urlFor = (pick) => {
        const values = $$('input[type=radio]:checked, select', this).map((x) => {
          if (pick && x.type === 'radio' && x.name === pick.name) return pick.dataset.valueId;
          return x.dataset.valueId || x.selectedOptions?.[0]?.dataset.valueId;
        }).filter(Boolean);
        return `${this.dataset.url}?option_values=${values.join(',')}&section_id=${this.closest('[data-section-id]').dataset.sectionId}`;
      };
      const load = (url) => { if (!VARIANT_CACHE.has(url)) VARIANT_CACHE.set(url, fetch(url).then((r) => (r.ok ? r.text() : Promise.reject(r.status))).catch((x) => { VARIANT_CACHE.delete(url); throw x; })); return VARIANT_CACHE.get(url); };
      const warm = (e) => { const lab = e.target.closest('label, input[type=radio]'); const inp = lab && (lab.matches('input') ? lab : lab.querySelector('input[type=radio]') || document.getElementById(lab.htmlFor)); if (inp && !inp.checked && this.contains(inp)) load(urlFor(inp)).then(preloadFirst).catch(() => {}); };
      /* also fetch the first gallery image of the warmed variant, so the switch never waits for it */
      const preloadFirst = (html, n = 1) => {
        const g = html.indexOf('<loupe-gallery'); if (g < 0) return;
        const re = /<img[^>]*?srcset="([^"]+)"[^>]*?sizes="([^"]+)"/g; re.lastIndex = g; let m;
        for (let i = 0; i < n && (m = re.exec(html)); i++) { if (PRELOADED.has(m[1])) continue; PRELOADED.add(m[1]); const im = new Image(); im.sizes = m[2]; im.srcset = m[1].replace(/&amp;/g, '&'); }
      };
      this.addEventListener('pointerover', warm, { passive: true }); this.addEventListener('focusin', warm); this.addEventListener('touchstart', warm, { passive: true });
      /* on the visitor's first interaction, quietly render every value of the first option (usually colour) and preload its
         first photos, so switching is instant instead of waiting for the server + image. Skipped on data-saver connections. */
      const warmAll = async () => {
        if (navigator.connection && navigator.connection.saveData) return;
        const group = this.querySelector('fieldset'); if (!group) return;
        const n = matchMedia('(min-width: 990px)').matches ? 4 : 1;
        for (const inp of $$('input[type=radio]', group).slice(0, 12)) {
          if (!this.isConnected) return;
          try { preloadFirst(await load(urlFor(inp)), n); } catch (e) {}
        }
      };
      if (!LoupeVariantPicker.warmed) {
        LoupeVariantPicker.warmed = true;
        const go = () => { ['pointermove', 'touchstart', 'scroll', 'keydown'].forEach((t) => removeEventListener(t, go)); (window.requestIdleCallback || setTimeout)(() => warmAll()); };
        ['pointermove', 'touchstart', 'scroll', 'keydown'].forEach((t) => addEventListener(t, go, { passive: true }));
      }
      this.addEventListener('change', async (e) => {
        const input = e.target.closest('input[type=radio], select'); if (!input) return;
        const section = this.closest('[data-section-id]');
        const url = urlFor();
        section.classList.add('is-busy');
        try {
          const html = await load(url);
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-section-id]');
          const keep = document.activeElement && document.activeElement.id;
          const variantId = fresh && fresh.dataset.variantId;
          if (fresh) {
            const oldImg = section.querySelector('[data-gallery] img');
            ['[data-product-info]', '[data-gallery]'].forEach((sel) => { const a = section.querySelector(sel), b = fresh.querySelector(sel); if (a && b) a.replaceWith(b); });
            section.dataset.variantId = variantId;
            /* switch at once; the previous photo stays on top until the new one has loaded, then fades away */
            const newImg = section.querySelector('[data-gallery] img');
            if (oldImg && newImg && !newImg.complete && oldImg.currentSrc) {
              const ghost = oldImg.cloneNode(); ghost.removeAttribute('srcset'); ghost.removeAttribute('loading'); ghost.src = oldImg.currentSrc; ghost.alt = ''; ghost.setAttribute('aria-hidden', 'true');
              ghost.classList.add('is-ghost'); newImg.insertAdjacentElement('afterend', ghost);
              const done = () => { ghost.style.opacity = '0'; setTimeout(() => ghost.remove(), 260); };
              newImg.addEventListener('load', done, { once: true }); newImg.addEventListener('error', done, { once: true }); setTimeout(done, 4000);
            }
          }
          if (variantId && this.dataset.updateUrl !== 'false') history.replaceState({}, '', `${this.dataset.url}?variant=${variantId}`);
          if (keep) { const f = document.getElementById(keep); f && f.focus(); }
        } finally { section.classList.remove('is-busy'); }
      });
    }
  }
  customElements.define('loupe-variant-picker', LoupeVariantPicker);

  /* ---------- card swatches: switch image + link on hover / tap ---------- */
  document.addEventListener('mouseover', swatch); document.addEventListener('focusin', swatch); document.addEventListener('click', (e) => { if (e.target.closest('.card .swatch')) { e.preventDefault(); swatch(e); } });
  function swatch(e) {
    const s = e.target.closest && e.target.closest('.card .swatch'); if (!s) return;
    const card = s.closest('.card'), img = card.querySelector('.card__media img');
    $$('.swatch', card).forEach((x) => x.classList.toggle('is-active', x === s));
    card.classList.add('is-swatched'); clearTimeout(card._sw); card._sw = setTimeout(() => card.classList.remove('is-swatched'), 2500);
    if (s.dataset.img && img) { img.srcset = s.dataset.srcset || ''; img.src = s.dataset.img; }
    const hov = card.querySelector('.card__img-2');
    if (hov) { hov.removeAttribute('srcset'); hov.src = s.dataset.img2 || s.dataset.img || hov.src; }
    if (s.dataset.url) $$('a[href]', card).forEach((a) => { if (!a.closest('.swatches')) a.href = s.dataset.url; });
    const vi = card.querySelector('[data-card-variant]'); if (vi && s.dataset.variant) vi.value = s.dataset.variant;
  }

  /* ---------- facets: ajax filtering without reloads ---------- */
  class LoupeFacets extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (e) => { const f = e.target.closest('[data-facets-form]'); if (f && e.target.closest('input, select')) { clearTimeout(this.t); this.t = setTimeout(() => this.submit(f), e.target.type === 'number' ? 600 : 0); } });
      this.addEventListener('submit', (e) => { if (!e.target.matches('[data-facets-form]')) return; e.preventDefault(); this.submit(e.target); });
      document.addEventListener('click', (e) => { const a = e.target.closest('[data-facet-link]'); if (a) { e.preventDefault(); this.load(a.href); } });
      addEventListener('popstate', () => this.load(location.href, false));
    }
    submit(form) {
      const fd = new FormData(form); const p = new URLSearchParams();
      for (const [k, v] of fd) if (v !== '') p.append(k, v);
      $$('form[data-facets-form]').forEach((f) => { if (f !== form) for (const [k, v] of new FormData(f)) if (v !== '' && !p.has(k)) p.append(k, v); });
      this.load(`${location.pathname}?${p}`);
    }
    async load(url, push = true) {
      const target = $('[data-facets-results]'); if (!target) return (location.href = url);
      target.classList.add('is-busy');
      const u = new URL(url, location.origin); u.searchParams.set('section_id', target.dataset.facetsResults);
      const html = await (await fetch(u)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      $$('[data-facets-swap]').forEach((el) => { const n = doc.querySelector(`[data-facets-swap="${el.dataset.facetsSwap}"]`); if (n) el.innerHTML = n.innerHTML; });
      if (push) history.pushState({}, '', url.replace(/[?&]section_id=[^&]*/, ''));
      target.classList.remove('is-busy');
    }
  }
  customElements.define('loupe-facets', LoupeFacets);
  // Range slider for the price filter and for filters whose values are all numbers (frame width, lens height…).
  // "values" mode ticks the hidden checkboxes inside the chosen range before the filter form refreshes.
  class LoupeRange extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      const [lo, hi] = this.querySelectorAll('.frange__track input'), [f1, f2] = this.querySelectorAll('.frange__fields input');
      const min = +lo.min, max = +lo.max, span = max - min || 1, values = this.dataset.mode === 'values';
      const paint = () => { const a = Math.min(+lo.value, +hi.value), b = Math.max(+lo.value, +hi.value); this.style.setProperty('--lo', (a - min) / span); this.style.setProperty('--hi', (b - min) / span); return [a, b]; };
      const r1 = (x) => Math.round(x * 10) / 10, fields = ([a, b]) => { f1.value = a > min ? (values ? r1(a) : Math.floor(a)) : ''; f2.value = b < max ? (values ? r1(b) : Math.ceil(b)) : ''; };
      const apply = () => { const [a, b] = paint(); if (values) { const all = a <= min && b >= max; this.querySelectorAll('input[type=checkbox]').forEach((c) => { c.checked = !all && +c.dataset.n >= a - 1e-9 && +c.dataset.n <= b + 1e-9; }); } fields([a, b]); };
      [lo, hi].forEach((r) => { r.addEventListener('input', () => { if (+lo.value > +hi.value) (r === lo ? lo : hi).value = (r === lo ? hi : lo).value; fields(paint()); }); r.addEventListener('change', apply); });
      [f1, f2].forEach((f) => f.addEventListener('change', () => { lo.value = f1.value === '' ? min : Math.max(min, Math.min(max, +f1.value)); hi.value = f2.value === '' ? max : Math.max(min, Math.min(max, +f2.value)); if (+lo.value > +hi.value) [lo.value, hi.value] = [hi.value, lo.value]; values ? apply() : paint(); }));
      paint();
    }
  }
  customElements.define('loupe-range', LoupeRange);

  /* ---------- gallery: dots on mobile, lightbox ---------- */
  class LoupeGallery extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.gallery'), items = track ? [...track.children] : [];
      const dots = $$('.gallery__dots i', this), thumbs = $$('[data-gallery-go]', this), cur = this.querySelector('[data-gallery-current]');
      const index = () => { const step = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : 1; return Math.max(0, Math.min(items.length - 1, Math.round(track.scrollLeft / step))); };
      let last = -1;
      const mark = () => {
        const i = index(); if (i === last) return; last = i;
        dots.forEach((d, n) => d.classList.toggle('on', n === i));
        thumbs.forEach((t, n) => { const on = n === i; t.classList.toggle('is-active', on); on ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current'); });
        const t = thumbs[i]; if (t) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
        if (cur) cur.textContent = i + 1;
      };
      if (track && items.length > 1) track.addEventListener('scroll', mark, { passive: true });
      thumbs.forEach((t) => t.addEventListener('click', () => { const it = items[+t.dataset.galleryGo]; if (it) track.scrollTo({ left: it.offsetLeft - items[0].offsetLeft, behavior: 'smooth' }); }));
      this.addEventListener('click', (e) => {
        const it = e.target.closest('[data-zoom]'); if (!it) return;
        const m = document.createElement('div'); m.className = 'modal'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true');
        m.innerHTML = `<button class="icon-btn modal__close" aria-label="${this.dataset.closeLabel || 'Close'}"><svg class="icon" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button><img src="${it.dataset.zoom}" alt="">`;
        const close = () => { m.remove(); lock(false); it.focus(); };
        m.addEventListener('click', close); m.addEventListener('keydown', (k) => k.key === 'Escape' && close());
        document.body.append(m); lock(true); m.querySelector('button').focus();
      });
    }
  }
  customElements.define('loupe-gallery', LoupeGallery);

  /* ---------- predictive search ---------- */
  class LoupeSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type=search]'); this.out = this.querySelector('[data-search-results]');
      if (!this.input || !this.out) return;
      this.input.addEventListener('input', () => { clearTimeout(this.t); this.t = setTimeout(() => this.run(), 220); });
    }
    async run() {
      const q = this.input.value.trim(), empty = this.querySelector('[data-search-empty]');
      if (empty) empty.hidden = !!q;
      if (!q) { this.out.innerHTML = ''; return; }
      const r = await fetch(`${L.routes.search}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[limit]=6&resources[limit_scope]=each`);
      if (!r.ok) return;
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const res = doc.querySelector('[data-predictive]'); this.out.innerHTML = res ? res.innerHTML : '';
    }
  }
  customElements.define('loupe-search', LoupeSearch);

  /* ---------- product recommendations (lazy, after the page) ---------- */
  class LoupeRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.children.length) return;
      const io = new IntersectionObserver(async (es) => {
        if (!es[0].isIntersecting) return; io.disconnect();
        // the product's linked colour products (separate products per colour) are already in its swatches: leave them out
        const ex = (this.dataset.exclude || '').split(',').map((h) => h.trim()).filter(Boolean);
        const lim = +(new URL(this.dataset.url, location.origin).searchParams.get('limit') || 4);
        const url = ex.length ? this.dataset.url.replace(/([?&])limit=\d+/, `$1limit=${Math.min(10, lim + ex.length)}`) : this.dataset.url;
        const html = await (await fetch(url)).text();
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('loupe-recommendations');
        if (fresh && ex.length) {
          let kept = 0;
          $$('.grid > li', fresh).forEach((li) => { const a = li.querySelector('a[href*="/products/"]'); const h = a ? a.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0] : '';
            if (ex.includes(h) || kept >= lim) li.remove(); else kept++; });
          if (!kept) fresh.innerHTML = '';
        }
        if (fresh && fresh.innerHTML.trim()) { this.innerHTML = fresh.innerHTML; $$('.reveal', this).forEach((x) => x.classList.add('in')); }
        else this.closest('.section')?.remove();
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  }
  customElements.define('loupe-recommendations', LoupeRecommendations);

  /* ---------- cart recommendations (drawer + cart page), loaded after the cart renders ---------- */
  /* cart recommendations: fetched only when the cart is about to be seen (drawer opening, cart icon hovered, cart page), cached per URL */
  const RECS = new Map();
  const recsFor = (url, fallback) => {
    if (!RECS.has(url)) RECS.set(url, (async () => {
      const pick = async (u) => new DOMParser().parseFromString(await (await fetch(u)).text(), 'text/html').querySelector('[data-cart-recs]');
      const empty = (b) => !b || !b.children.length;
      let box = await pick(url);
      if (empty(box) && url.includes('intent=complementary')) box = await pick(url.replace('intent=complementary', 'intent=related'));   // no complementary set up: use related
      if (empty(box) && fallback) box = await pick(fallback);   // no recommendation data yet: show the merchant's chosen collection
      return box ? box.innerHTML : '';
    })().catch(() => { RECS.delete(url); return ''; }));
    return RECS.get(url);
  };
  class LoupeCartRecs extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url; if (!url || url.includes('product_id=&')) return;
      const go = () => { if (this.started) return; this.started = true; recsFor(url, this.dataset.fallback).then((html) => { if (html && this.isConnected) this.innerHTML = html; }); };
      const drawer = this.closest('.drawer');
      if (!drawer || drawer.classList.contains('is-open')) return go();
      this.mo = new MutationObserver(() => { if (drawer.classList.contains('is-open')) { this.mo.disconnect(); go(); } });
      this.mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      const warm = (e) => { if (e.target.closest && e.target.closest('[data-drawer-open="cart-drawer"]')) go(); };
      document.addEventListener('pointerover', warm, { passive: true }); document.addEventListener('focusin', warm);
      this.off = () => { document.removeEventListener('pointerover', warm); document.removeEventListener('focusin', warm); };
    }
    disconnectedCallback() { this.mo && this.mo.disconnect(); this.off && this.off(); }
  }
  customElements.define('loupe-cart-recs', LoupeCartRecs);

  /* ---------- product carousels: arrow buttons ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-carousel]'); if (!b) return;
    const root = b.closest('.shopify-section') || document, track = root.querySelector('[data-carousel-track]:not([hidden] *)') || root.querySelector('[data-carousel-track]');
    if (track) track.scrollBy({ left: +b.dataset.carousel * track.clientWidth * 0.9, behavior: 'smooth' });
  });

  /* ---------- tabs (featured collection etc.) ---------- */
  document.addEventListener('click', (e) => { const t = e.target.closest('[role=tab]'); if (t) pickTab(t); });
  document.addEventListener('keydown', (e) => {
    const t = e.target.closest && e.target.closest('[role=tab]'); if (!t || !['ArrowRight', 'ArrowLeft'].includes(e.key)) return;
    const tabs = $$('[role=tab]', t.closest('[role=tablist]')), i = tabs.indexOf(t), n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
    n.focus(); pickTab(n);
  });
  function pickTab(t) {
    $$('[role=tab]', t.closest('[role=tablist]')).forEach((x) => { const on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; const p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
  }

  /* ---------- reveal on scroll ---------- */
  if (document.documentElement.classList.contains('anim') && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } }), { rootMargin: '0px 0px -8% 0px' });
    const watch = () => $$('.reveal:not(.in)').forEach((el) => io.observe(el));
    watch(); document.addEventListener('shopify:section:load', watch);
    /* content swapped in later (filters, load more, recommendations, quick view) fades in too */
    new MutationObserver((ms) => { for (const m of ms) for (const n of m.addedNodes) if (n.nodeType === 1 && (n.matches('.reveal:not(.in)') || n.querySelector('.reveal:not(.in)'))) return watch(); })
      .observe(document.body, { childList: true, subtree: true });
  } else $$('.reveal').forEach((el) => el.classList.add('in'));

  /* ---------- tall sticky columns stick by their bottom edge so every block stays reachable ---------- */
  if ('ResizeObserver' in window) {
    const fit = (el) => {
      const head = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 68;
      const bar = document.querySelector('.sticky-atc');
      el.style.setProperty('--sticky-top', Math.min(head, innerHeight - el.offsetHeight - (bar ? bar.offsetHeight : 0)) + 'px');
    };
    const ro = new ResizeObserver((es) => es.forEach((x) => fit(x.target)));
    const watchSticky = () => $$('.buy').forEach((el) => ro.observe(el));
    watchSticky(); document.addEventListener('shopify:section:load', watchSticky);
    addEventListener('resize', () => $$('.buy').forEach(fit), { passive: true });
  }

  /* ---------- instant pages: warm the next page on hover/touch (browsers without speculation rules) ---------- */
  if (!(HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) && !(navigator.connection && navigator.connection.saveData)) {
    const done = new Set();
    const warm = (e) => {
      const a = e.target.closest && e.target.closest('a[href]'); if (!a || a.target === '_blank' || a.hasAttribute('download') || a.closest('[data-no-prefetch]')) return;
      const u = new URL(a.href, location.href);
      if (u.origin !== location.origin || u.hash && u.pathname === location.pathname || /^\/(cart|checkout|account|apps)/.test(u.pathname) || done.has(u.href)) return;
      done.add(u.href); const l = document.createElement('link'); l.rel = 'prefetch'; l.href = u.href; document.head.append(l);
    };
    let t; document.addEventListener('pointerover', (e) => { clearTimeout(t); t = setTimeout(() => warm(e), 65); }, { passive: true });
    document.addEventListener('touchstart', warm, { passive: true });
  }

  /* ---------- scroll motion: tag elements once, the CSS does the rest ---------- */
  const motion = document.documentElement.className.match(/motion-(subtle|cinematic)/);
  if (motion && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const cine = motion[1] === 'cinematic';
    const rio = 'IntersectionObserver' in window && new IntersectionObserver((es) => es.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('in'); rio.unobserve(x.target); } }), { rootMargin: '0px 0px -10% 0px' });
    const SKIP = '.card, .reveal, .lp-rise, header, footer, .drawer, .mega, loupe-quick-view, .sticky-atc, .buy, .abar';
    const tagSection = (sec) => {
        // read everything first, then write (mixing them forces a layout per element); text already on screen stays put
        const vh = innerHeight, picked = $$(':is(h1, h2, h3, .eyebrow, .rte > p, .btn, .link):not(:empty)', sec)
          .filter((el) => !el.closest(SKIP) && el.offsetParent !== null && el.getBoundingClientRect().top > vh);
        picked.forEach((el, i) => { el.classList.add('lp-rise'); el.style.setProperty('--i', Math.min(i, 6)); rio && rio.observe(el); });
        if (cine) $$(':is(figure, [class*="__media"], [class*="__figure"], picture):not(.card__media, .gallery__item, .rec__media, .mm__tile-media, .mm__card-media, .gallery-stage)', sec).forEach((m) => {
          if (m.closest('.card, .gallery, .drawer, header, .mega, loupe-quick-view') || !m.querySelector('img') || m.querySelector('.lp-zoom')) return;
          m.classList.add('lp-zoom');
        });
    };
    const tagRest = () => {
      /* product cards in a row come in one after another */
      $$('.grid > li.reveal', document).forEach((li, k) => li.style.setProperty('--i', k % 4));
      /* statements: wrap words so they can light up while scrolling */
      if (cine) $$('main :is(.rt__statement p, .pgst__text, .statement p, [data-words])').forEach((el) => {
        if (el.classList.contains('lp-words')) return;
        const words = []; const walk = (n) => { [...n.childNodes].forEach((c) => {
          if (c.nodeType === 3) { const f = document.createDocumentFragment(); c.textContent.split(/(\s+)/).forEach((t) => { if (!t) return; if (/^\s+$/.test(t)) f.append(t); else { const w = document.createElement('span'); w.className = 'lp-w'; w.textContent = t; words.push(w); f.append(w); } }); c.replaceWith(f); }
          else if (c.nodeType === 1) walk(c); }); };
        walk(el); el.classList.add('lp-words'); words.forEach((w, k) => w.style.setProperty('--wp', (k / Math.max(words.length - 1, 1)).toFixed(3)));
      });
    };
    // the first section is above the fold: shown at once (no fade, better LCP)
    const sections = () => $$('main .shopify-section').slice(1);
    const tag = () => { sections().forEach(tagSection); tagRest(); };
    // after load, one section at a time in idle moments: no long task, nothing added to the first paint
    const queue = () => {
      const todo = sections(); let rest = true;
      const step = (dl) => {
        do { const sec = todo.shift(); if (sec) tagSection(sec); else if (rest) { rest = false; tagRest(); } else return; }
        while (dl && dl.timeRemaining && dl.timeRemaining() > 6);
        ric(step);
      };
      ric(step);
    };
    const ric = (fn) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 2000 }) : setTimeout(fn, 50));
    if (document.readyState === 'complete') queue(); else addEventListener('load', queue, { once: true });
    document.addEventListener('shopify:section:load', tag);
  }

  /* ---------- the footer wordmark fills the full width exactly ---------- */
  const fitWords = () => $$('[data-fit]').forEach((el) => {
    const span = el.firstElementChild; if (!span) return;
    el.style.fontSize = ''; const w = span.getBoundingClientRect().width; if (!w) return;
    el.style.fontSize = (parseFloat(getComputedStyle(el).fontSize) * el.clientWidth / w * 0.995) + 'px';
  });
  if (document.fonts) document.fonts.ready.then(fitWords); else addEventListener('load', fitWords);
  addEventListener('resize', () => { clearTimeout(fitWords.t); fitWords.t = setTimeout(fitWords, 150); }, { passive: true });

  /* filters: show more / less */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-facet-more]'); if (!b) return;
    const list = b.previousElementSibling; const open = !list.classList.contains('is-expanded');
    list.classList.toggle('is-expanded', open); b.setAttribute('aria-expanded', open);
    b.children[0].hidden = open; b.children[1].hidden = !open;
  });

  /* ---------- theme editor: open drawers / re-init when sections reload ---------- */
  document.addEventListener('shopify:section:select', (e) => { if (e.target.querySelector('#cart-drawer')) $('#cart-drawer').open(); });
})();
